/**
 * Human-readable byte size (e.g. `30.0 MB`). Shared by the document list and
 * the AI-review size notices so the displayed limit is always derived from
 * `AI_REVIEW_MAX_BYTES` rather than hardcoded.
 */
export function formatBytes(bytes: number | null): string {
	if (bytes == null) return ""
	if (bytes < 1024) return `${bytes} B`
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
